var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_vm._v(" 2022 © Centro Tecnológico Naval y del Mar -   "),_c('a',{staticStyle:{"margin-left":"6px"},attrs:{"href":"#"}},[_vm._v("Portal Web")])])
}]

export { render, staticRenderFns }